import { createTheme } from "@mui/material/styles"

const theme = createTheme({
  palette: {
    primary: {
      main: "#1565C0", // Verde, cambia questo con il colore che vuoi
    },
  },
})

export default theme
